import { graphql } from "gatsby";
import NewsItemPage from "../components/news-item"

export default NewsItemPage

export const query = graphql`
    query NewsItemPage($id: String!, $previousId: String, $nextId: String) {
        site {
            siteMetadata {
                title
            }
        }
        newsPost(id: { eq: $id }) {
            id
            excerpt
            body
            slug
            title
            tags
            author
            date(formatString: "MMMM DD, YYYY")
        }
        previous: newsPost(id: { eq: $previousId }) {
            id
            excerpt
            slug
            title
            date(formatString: "MMMM DD, YYYY")
        }
        next: newsPost(id: { eq: $nextId }) {
            id
            excerpt
            slug
            title
            date(formatString: "MMMM DD, YYYY")
        }
    }
`